import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

import { Box } from '@/components/box';
import { Flex } from '@/components/flex';
import { Text } from '@/components/text';

interface Props {
  message?: string;
  secondaryMessage?: string;
  showClearFiltersBtn?: boolean;
  imageName?: string;
  onResetFilters: () => void;
}

const NoResultsRow = ({
  message = 'No results found that matched your filters.',
  secondaryMessage = 'Try updating your selections, or',
  showClearFiltersBtn = true,
  imageName = 'question-marker',
  onResetFilters,
}: Props) => {
  const handleResetFilters = () => {
    onResetFilters();
  };

  return (
    <Row>
      <Flex alignItems="center">
        <ImageIcon src={imageName} />
        <Box ml="base">
          <Text className="m-0 mb-2 text-baseSm font-medium">{message}</Text>
          <Text className="m-0 text-baseSm italic text-text-secondary">
            {secondaryMessage}{' '}
            {Boolean(showClearFiltersBtn) && (
              <StyledButton onClick={handleResetFilters}>clear all filters</StyledButton>
            )}
          </Text>
        </Box>
      </Flex>
    </Row>
  );
};

const Row = styled.div`
  color: ${themeGet('colors.text.primary')};
  background: white;
  border: 1px solid ${themeGet('colors.grey.200')};
  border-width: 1px 0px;
  line-height: ${themeGet('lineHeights.tight')};
  margin-top: ${themeGet('space.xs')};
  padding: ${themeGet('space.md')} ${themeGet('space.lg')};
  position: relative;
  z-index: ${themeGet('zIndices.5')};
`;

const StyledButton = styled.button`
  color: ${themeGet('colors.lightBlue.500')};
  font-style: italic;
  text-decoration: underline;

  &:hover {
    color: ${themeGet('colors.lightBlue.700')};
  }
`;

interface ImageIconProps {
  readonly src: string;
}

const ImageIcon = styled.span<ImageIconProps>`
  background: url(/assets/${({ src }) => src}.png);
  display: block;
  width: ${themeGet('space.xl')};
  height: ${themeGet('space.xl')};
  background-size: contain;
`;

export { NoResultsRow };
